import * as actionTypes from '../actionTypes/Feedback'

export const setFeedbackStateRequest = () => ({
    type: actionTypes.SET_FEEDBACK_STATE_REQUEST,
})

export const setFeedbackStateSuccess = feedbackQuestion => ({
    type: actionTypes.SET_FEEDBACK_STATE_SUCCESS,
    feedbackQuestion,
})

export const setFeedbackStateFailure = error => ({
    type: actionTypes.SET_FEEDBACK_STATE_FAILURE,
    error,
})

export const setFeedbackQuestion = feedbackQuestion => {
    return {
        type: actionTypes.SET_FEEDBACK_QUESTION,
        feedbackQuestion,
    }
}

export const submitFeedbackSuccess = status => ({
    type: actionTypes.SUBMIT_FEEDBACK_SUCCESS,
    status,
})
